type DataListType = {
  label?: string | undefined;
  value?: number | string | undefined;
}[];

type MultiDataListType = {
  value?: string | undefined;
  label?: string | undefined;
  stateId?: string | undefined;
  stateName?: string | undefined;
}[];

type MultiBlocksType = {
  value?: string | undefined;
  label?: string | undefined;
  stateId?: string | undefined;
  stateName?: string | undefined;
  districtId?: string | undefined;
  districtName?: string | undefined;
}[];

type MultiVillagesType = {
  value?: string | undefined;
  label?: string | undefined;
  stateId?: string | undefined;
  stateName?: string | undefined;
  districtId?: string | undefined;
  districtName?: string | undefined;
  blockId?: string | undefined
  blockName?: string | undefined
}[];


type SurveyorsDataListType ={
  label?:string | undefined ;
  value ?:number | string |undefined;
  accessTo?:string[];

}[];
type Response = {
  id?: number;
  value?: string;
};

type vendorResponse = {
  vendorCode: string;
  vendorName: string;
};

type SearchResponse = {
  name?: string;
  mobile?: number;
};

type YearsResponse = {
  label?: number;
  value?: number;
};

export class FormUtils {
  static convertDataList(data: Response[]): DataListType {
    return data.map((item: any) => ({
      label: item.value,
      value: item.id,
    }));
  }
  static convertVendorData(data: vendorResponse[]): DataListType {
    return data?.map((item: any) => ({
      label: `${item.vendorCode} - ${item.vendorName} `,
      value: item.vendorCode,
    }));
  }
  static convertMultiDataDistrictList(data: Response[]): MultiDataListType {
    return data.map((item: any) => ({
      label: item.districtName,
      value: item.districtId,
      stateId: item.stateId,
      stateName: item.stateName,
    }));
  }
  static convertMultiBlocksList(data: Response[]): MultiBlocksType {
    return data.map((item: any) => ({
      label: item.mandalName,
      value: item.mandalId,
      stateId: item.stateId,
      stateName: item.stateName,
      districtId: item.districtId,
      districtName: item.districtName,
    }));
  }

  static convertMultiVillagesList(data: Response[]): MultiVillagesType {
    return data.map((item: any) => ({
      label: item.villageName,
      value: item.villageId,
      stateId: item.stateId,
      stateName: item.stateName,
      districtId: item.districtId,
      districtName: item.districtName,
      blockId: item.mandalId,
      blockName: item.mandalName,
    }));
  }
  static convertDataListValue(data: Response[]): DataListType {
    return data.map((item: any) => ({
      label: item.value,
      value: item.value,
    }));
  }
  static convertToDataListObject(data: Response[]): DataListType {
    return data.flatMap((item: Response) => ({
      label: String(item),
      value: String(item),
    }));
  }
  static convertCCEUserDataList(data: Response[]): SurveyorsDataListType {
    return data
      .filter((item: any) => item?.accessTo?.includes("ICV"))
      .map((item: any) => ({
        label: `${item.mobileNumber} - ${item.userName}`,
        value: item.mobileNumber,
        accessTo: item.accessTo,
      }));
  }

  static convertCropDataList(data: Response[]): DataListType {
    return data.map((item: any) => ({
      label: item.mobile,
      value: item.mobile,
    }));
  }
  static convertYearDataList(data: Response[]): DataListType {
    return data.map((item: any) => ({
      label: item.year,
      value: item.year,
    }));
  }
  static convertPMFBYVillageDataList(data: Response[]): DataListType {
    return data?.map((item: any) => ({
      label: item.villageName,
      value: item.pmfbyVillageId,
    }));
  }
  static convertVillagesDataList(data: Response[]): DataListType {
    return data?.map((item: any) => ({
      label: item.ncipVillageName,
      value: item.ncipVillageId,
      kshemaDistrictId: item.kshemaDistrictId,
      kshemaMandalId: item.kshemaMandalId,
      kshemaVillageId: item.kshemaVillageId,
      kshemaStateName: item.kshemaStateName,
      kshemaStateId: item.kshemaStateId,
      kshemaDistrictName: item.kshemaDistrictName,
      kshemaMandalName: item.kshemaMandalName,
      kshemaVillageName: item.kshemaVillageName,
      ncipStateName: item.ncipStateName,
      ncipDistrictName: item.ncipDistrictName,
      ncipLevel4Name: item.ncipLevel4Name,
      ncipLevel5Name: item.ncipLevel5Name,
      ncipLevel6Name: item.ncipLevel6Name,
      ncipStateId: item.ncipStateId,
      ncipDistrictId: item.ncipDistrictId,
      ncipLevel4Id: item.ncipLevel4Id,
      ncipLevel5Id: item.ncipLevel5Id,
      ncipLevel6Id: item.ncipLevel6Id,
    }));
  }
  static convertSurveyorDataList(data: any[]) {
    return data.map((item: any) => ({
      label: `${item.mobile} - ${item.name}`,
      value: `${item.mobile}`,
    }));
  }

  static convertSearchDataList(data: SearchResponse[]): DataListType {
    return data.map((item: SearchResponse) => ({
      label: `${item.mobile} :   ${item.name}`,
      value: item.mobile,
    }));
  }

  static convertbleYearsList(data: YearsResponse[]): DataListType {
    return data.map((item: YearsResponse) => ({
      label: `${item.label}`,
      value: `${item.value}`,
    }));
  }
}

export interface SelectOptionType {
  value: number | string;
  label: number | string;
}
